import { Node } from "@tiptap/core";
import { checkAndHandleMatrixCellCitation } from "../common/MarkDownRenderer";

const EditorHighlightNumberNode = Node.create({
  name: "editor-highlight-number",
  group: "inline",
  content: "text*",
  inline: true,
  // atom: true,

  addAttributes() {
    return {
      numValue: {
        default: null,
      },
      qid: {
        default: null,
      },
      originalNumValue: {
        default: null,
      },
    };
  },

  // No plain-text serializer here on purpose. A `toText` key used to sit on
  // this config; tiptap has never read one — the hook that reaches a node's
  // ProseMirror `spec.toText` is called `renderText` — so it was dead in v2
  // and is a type error in v3, whose NodeConfig no longer accepts stray keys.
  // Removing it changes nothing; adding a real `renderText` would change what
  // `editor.getText()` produces for a citation, which is a product call rather
  // than part of this dependency bump (#11904).

  parseHTML() {
    return [
      {
        tag: "editor-highlight-number",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    // console.log("HTMLAttributes", HTMLAttributes);
    return [
      "editor-highlight-number",
      {
        ...HTMLAttributes,
        "data-text-content": HTMLAttributes.originalNumValue,
      },

      (HTMLAttributes.originalNumValue || "").toString(),
    ];
  },

  addNodeView() {
    return ({
      editor,
      node,
      getPos,
      HTMLAttributes,
      decorations,
      extension,
    }) => {
      const { numValue, qid, originalNumValue } = node.attrs;
      const dom = document.createElement("span");

      dom.innerHTML = originalNumValue;
      dom.className = "text-blue-600 cursor-pointer";

      dom.onclick = async (e) => {
        e.preventDefault(); // Prevent default behavior
        e.stopPropagation(); // Stop event from bubbling up

        // Check if this citation references a matrix cell (for matrix workspaces)
        if (qid && numValue) {
          const isMatrixCellCitation = await checkAndHandleMatrixCellCitation(
            numValue,
            qid,
            originalNumValue || ""
          );
          if (isMatrixCellCitation) {
            // Matrix cell citation was handled, don't open document panel
            return;
          }
        }

        // Default behavior: Dispatch window event to open document panel
        window.dispatchEvent(
          new CustomEvent("openDocumentPanel", {
            detail: {
              citationId: numValue,
              queryId: qid,
              originalNumValue,
            },
          })
        );

        // Also call handleReferenceClick if available for backward compatibility
        if ((window as any).handleReferenceClick) {
          (window as any).handleReferenceClick(e, {
            originalNumValue,
            qid,
            numValue,
          });
        }
      };

      return {
        dom,
      };
    };
    // return ReactNodeViewRenderer(EditorHighlightNumberComponent);
  },
});

export default EditorHighlightNumberNode;
